import React, { useState, useEffect, useRef, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

const LazySection = ({ children, fallback, id, className, style }) => {
  const location = useLocation();
  // If navigating directly to a hash, load eagerly to prevent scroll-jump/layout shift bugs
  const hasHash = Boolean(location.hash);
  const [isVisible, setIsVisible] = useState(hasHash);
  const ref = useRef(null);

  useEffect(() => {
    if (isVisible) return; // Already visible, bypass observer

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: '100% 0px 100% 0px' }); // Load 1 viewport height before/after it comes into view

    const element = ref.current;
    if (element) observer.observe(element);
    
    return () => {
      if (element) observer.unobserve(element);
    }
  }, [isVisible]);

  return (
    <div 
      ref={ref} 
      id={id} 
      className={className} 
      style={{ minHeight: '100px', ...style }}
    >
      {isVisible ? (
        <Suspense fallback={fallback || <div className="section-loader" style={{height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Loading...</div>}>
          {children}
        </Suspense>
      ) : null}
    </div>
  );
};

export default LazySection;
